import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { usePlannerContext } from "../../../contexts/planner.contexts";
import {
  convertValue,
  formatCalculatedValue,
  formatValue,
} from "../../../services/helperService";
const ExpenseForm = ({ submit }) => {
  const {
    plannerData,
    handleBlur,
    onChangeHandler,
    handleKeyPress,
    handleFocus,
  } = usePlannerContext();

  const [formData, setformData] = useState({});

  const retirementFields = [
    // Section: Housing Costs
    { name: "Housing Costs", isHeading: true },
    { name: "Mortgage or Rent", isHeading: false },
    { name: "Real Estate Taxes", isHeading: false },
    { name: "Personal Debt", isHeading: false },
    { name: "Utilities", isHeading: false },
    { name: "Maintenance / Repair", isHeading: false },
    { name: "Insurance (Home / Renters)", isHeading: false },
    { name: "Other", isHeading: false },

    // Section: Personal Expenses
    { name: "Personal Expenses", isHeading: true },
    { name: "Groceries", isHeading: false },
    { name: "Clothing", isHeading: false },
    { name: "Grooming", isHeading: false },
    { name: "Medical Insurance", isHeading: false },
    { name: "Prescription Drugs", isHeading: false },
    { name: "Taxes (personal)", isHeading: false },
    { name: "Charitable Giving", isHeading: false },
    { name: "Other", isHeading: false },

    // Section: Transportation Costs
    { name: "Transportation Costs", isHeading: true },
    { name: "Auto Payment / Lease", isHeading: false },
    { name: "Auto Insurance", isHeading: false },
    { name: "Fuel / Maintenance", isHeading: false },
    { name: "Public Transportation", isHeading: false },
    { name: "Other", isHeading: false },

    // Section: Travel / Entertainment
    { name: "Travel / Entertainment", isHeading: true },
    { name: "Travel", isHeading: false },
    { name: "Entertainment", isHeading: false },
    { name: "Gifts to Others", isHeading: false },
    { name: "Other", isHeading: false },
    { name: "Other", isHeading: false },
  ];

  useEffect(() => {
    if (
      plannerData &&
      typeof plannerData === "object" &&
      Object.keys(plannerData).length > 0
    ) {
      let data = plannerData;
      data["expenses_field5"] =
        (convertValue(plannerData["pay_s2_32"]) * 26) / 12;
      data["expenses_field5"] = formatCalculatedValue(data["expenses_field5"]);
      let fieldNumber = 7;
      console.log(formData);
      setformData(data);
    }
  }, [plannerData]);

  const handleStateByField = (name, value) => {
    setformData({
      ...formData,
      [name]: value,
    });
  };

  const createExpenseFields = () => {
    return retirementFields.map((field, index) => {
      if (field.isHeading) {
        return (
          <tr key={index} style={{ backgroundColor: "#000", color: "#fff" }}>
            <th>
              <div className="title ps-2">{field.name}</div>
            </th>
            <th>
              <div className="title text-center">
                {index === 0 && "Current"}
              </div>
            </th>
            <th>
              <div className="title text-center">
                {index === 0 && "At Retirement"}
              </div>
            </th>
            <th>
              <div className="title text-center">
                {index === 0 && "Required"}
              </div>
            </th>
          </tr>
        );
      } else {
        const fieldNumber =
          index +
          1 -
          retirementFields.slice(0, index).filter((f) => f.isHeading).length;
        return (
          <tr>
            <td>
              <div className="title ps-2">
                {fieldNumber}. {field.name}
              </div>
            </td>
            <td>
              {" "}
              <div className="input-wrapper mt-1 px-2">
                $
                <div className="text-wrapper w-100">
                  <Form.Control
                    autoComplete="off"
                    className="input-box expense-input-large"
                    type="text"
                    name={"expenses_field_c" + fieldNumber}
                    placeholder="0.00"
                    value={formData["expenses_field_c" + fieldNumber]}
                    onChange={(event) => onChangeHandler(event, setformData)}
                    onBlur={(e) => handleBlur(e, true, setformData)}
                    onFocus={(event) => handleFocus(event, setformData)}
                    onKeyPress={(event) => handleKeyPress(event, setformData)}
                  />
                </div>
              </div>
            </td>
            <td>
              <div className="input-wrapper mt-1 px-2">
                $
                <div className="text-wrapper w-100">
                  <Form.Control
                    autoComplete="off"
                    className="input-box expense-input-large"
                    type="text"
                    placeholder="0.00"
                    name={"expenses_field_r" + fieldNumber}
                    value={formData["expenses_field_r" + fieldNumber]}
                    onChange={(event) => onChangeHandler(event, setformData)}
                    onBlur={(e) => handleBlur(e, true, setformData)}
                    onKeyPress={(event) => handleKeyPress(event, setformData)}
                    onFocus={(event) => handleFocus(event, setformData)}
                  />
                </div>
              </div>
            </td>
            <td className="text-center">
              <div className="retirement-label" style={{ display: "inline" }}>
                {formData["expenses_field_check" + fieldNumber] === "0" ||
                ([7, 14, 15, 20, 21, 22, 23, 24, 25].includes(fieldNumber) &&
                  formData["expenses_field_check" + fieldNumber] === null) ? (
                  <i
                    className="fa fa-square-o thrift-checker2"
                    onClick={() =>
                      handleStateByField(
                        "expenses_field_check" + fieldNumber,
                        "1"
                      )
                    }
                  ></i>
                ) : (
                  <i
                    className="fa fa-check-square-o thrift-checker"
                    onClick={() =>
                      handleStateByField(
                        "expenses_field_check" + fieldNumber,
                        "0"
                      )
                    }
                  ></i>
                )}
              </div>
            </td>
          </tr>
        );
      }
    });
  };

  const [total, setTotal] = useState(
    formatValue(formData["expenses_field_monthly_total"])
  );
  const [moneyLeftAfterPayment, setMoneyLeftAfterPayment] = useState(
    formatValue(formData["moneyLeftAfterPayment"])
  );
  const [currentTotal, setCurrentTotal] = useState(
    formatValue(formData["expenses_field_monthly_total2"])
  );
  const [netToBank, setNetToBank] = useState(formatValue(formData["money"]));
  useEffect(() => {
    let payload = {};
    payload["expenses_field_monthly_total"] = total;
    payload["expenses_field_monthly_total2"] = currentTotal;
    payload["money"] = netToBank;
    payload["moneyLeftAfterPayment"] = moneyLeftAfterPayment;
    if (formData && Object.keys(formData).length > 0) {
      const expenseFields = {};

      for (let i = 1; i <= 25; i++) {
        expenseFields[`expenses_field_check${i}`] =
          formData[`expenses_field_check${i}`] ||
          [7, 14, 15, 20, 21, 22, 23, 24, 25].includes(i)
            ? formData[`expenses_field_check${i}`]
            : "1";
      }

      setformData({
        ...formData,
        ...payload,
        ...expenseFields,
      });

      totalMonthlyExpense();
      retirementMonthlyExpense();
    }
  }, [moneyLeftAfterPayment, netToBank, currentTotal, total]);

  useEffect(() => {
    totalMonthlyExpense();
    retirementMonthlyExpense();
  }, [
    ...Array.from(
      { length: 25 },
      (_, i) => formData[`expenses_field_c${i + 1}`]
    ),
    ...Array.from(
      { length: 25 },
      (_, i) => formData[`expenses_field_r${i + 1}`]
    ),
    ...Array.from(
      { length: 25 },
      (_, i) => formData[`expenses_field_check${i + 1}`]
    ),
  ]);

  const totalMonthlyExpense = () => {
    let totalExpence = Array.from({ length: 25 }, (_, i) => i + 1)
      .filter((i) => formData[`expenses_field_check${i}`] === "1")
      .reduce(
        (sum, i) => sum + convertValue(formData[`expenses_field_c${i}`]),
        0
      );
    let money = convertValue(formData["pay_s2_36"]);
    money = (money * 26) / 12;
    setNetToBank(formatCalculatedValue(money));
    let moneyAfterPayment = 0;
    moneyAfterPayment = money - totalExpence;
    moneyAfterPayment = formatCalculatedValue(moneyAfterPayment);
    setMoneyLeftAfterPayment(moneyAfterPayment);
    totalExpence = formatCalculatedValue(totalExpence);
    setTotal(totalExpence ? totalExpence : "0.00");
  };

  const retirementMonthlyExpense = () => {
    let totalExpence = Array.from({ length: 25 }, (_, i) => i + 1)
      .filter((i) => formData[`expenses_field_check${i}`] === "1")
      .reduce(
        (sum, i) => sum + convertValue(formData[`expenses_field_r${i}`]),
        0
      );

    totalExpence = formatCalculatedValue(totalExpence);
    setCurrentTotal(totalExpence ? totalExpence : "0.00");
  };
  const submitFormdata = (event) => {
    submit(event, formData);
  };

  return (
    <>
      <Card.Body className="expense-form">
        <Form
          name="expense"
          noValidate
          onSubmit={submitFormdata}
          className="employee-form"
        >
          <div className="text-center">
            <div className="head-title">Income & Expenses</div>
          </div>

          <Row className="mb-2">
            <Col md={12}>
              <div className=" mt-3">
                <div className="panel-heading">
                  <i className="fa-solid fa-star start-icon"></i>
                  MFB TIP: Discretionary Income
                </div>
                <div className="small-rainy-text pt-2">
                  The portion of money left over, after all expenses is called
                  DISCRETIONARY INCOME. This number is important in determining
                  not only when you can retire, but when you can afford to
                  retire.
                </div>
                <div className="small-rainy-text pt-2">
                  To retire comfortably and with peace of mind, your income
                  should consistently exceed your expenses. Equally important is
                  maintaining an adequate emergency savings reserve, as the
                  likelihood of encountering unexpected—and potentially
                  significant—expenses over time is virtually certain.
                </div>
              </div>
            </Col>
          </Row>
          <div className="expense-container">
            <p className="expense-title">
              <strong>DEBT and EXPENSE ANALYSIS</strong>
            </p>
          </div>
          <div className="expense-container-2">
            <table style={{ width: "100%" }}>
              <colgroup>
                <col span="1" style={{ width: "45%" }} />
                <col span="1" style={{ width: "22%" }} />
                <col span="1" style={{ width: "23%" }} />
                <col span="1" style={{ width: "10%" }} />
              </colgroup>
              {createExpenseFields()}
            </table>
            <div className="expense-normal-space">
              <Row>
                <Col md={{ span: 10, offset: 1 }}>
                  <Row>
                    <Col md={{ span: 6, offset: 2 }}>
                      <p className="expense-normal ">
                        <span className="expense-bold">
                          Current Net to Bank:
                        </span>
                      </p>
                    </Col>
                    <Col md={4}>
                      <p className="expense-normal">
                        <span className="expense-bold">
                          ${netToBank ? netToBank : "0.00"}{" "}
                        </span>
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={{ span: 6, offset: 2 }}>
                      <p className="expense-normal ">
                        <span className="expense-bold ">
                          Total Approximate Expenses:
                        </span>
                      </p>
                    </Col>
                    <Col md={4}>
                      <p>
                        {" "}
                        <span className="expense-bold ">
                          ${total ? total : "0.00"}
                        </span>
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={{ span: 6, offset: 2 }}>
                      <p className="expense-normal ">
                        <span className="expense-bold ">
                          Remaining Discretionary Income:
                        </span>
                      </p>
                    </Col>
                    <Col md={4}>
                      <p className="expense-normal ">
                        <span
                          className={`expense-bold  ${
                            convertValue(moneyLeftAfterPayment) < 0 &&
                            "red-text"
                          }`}
                        >
                          {" "}
                          $
                          {moneyLeftAfterPayment
                            ? moneyLeftAfterPayment.replace("-", "")
                            : "0.00"}
                        </span>
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={{ span: 7, offset: 2 }} className="mt-2">
                      <div className="textbox-wrapper mt-4">
                        <select
                          name="is_your_current_take_home_pay"
                          value={formData.is_your_current_take_home_pay}
                          className={
                            formData.is_your_current_take_home_pay && "has-val"
                          }
                          onChange={(event) =>
                            onChangeHandler(event, setformData)
                          }
                        >
                          <option value=""></option>
                          <option value="More than enough">
                            More than enough
                          </option>
                          <option value="Just enough">Just enough</option>
                          <option value="Not enough">Not enough</option>
                        </select>

                        <div className="floating-placeholder">
                          Is your current take home pay:
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <div>
              <div className=" mt-3 mb-3">
                <div className="panel-heading">
                  <i className="fa-solid fa-star start-icon"></i>
                  MFB TIP: Transition to Retirement
                </div>
                <div className="small-rainy-text">
                  Your pre-retirement window, will be significant in your
                  transition to retirement. Working on reducing your current
                  debts, expenses, and lifestyle will determine your comfort
                  level at retirement and when you are able to retire.
                </div>
              </div>
            </div>
            <div>
              <div className="expense-dark-text-wrapper">
                <div className="expense-dark-heading">
                  Income & Expenses - ITEMS OF IMPORTANCE
                </div>
                <div className="expense-dark-sub-heading">
                  * Knowing exactly how much income <b>needed</b> before
                  retiring will help your transition into retirement. Spend the
                  time now to take inventory.
                </div>
              </div>
            </div>
          </div>
          <div className="btn-wrapper">
            <div className="text-center mt-4">
              <button className="btn-next btn question-next" type="submit">
                CONTINUE
              </button>
            </div>
          </div>
        </Form>
      </Card.Body>
    </>
  );
};

export default ExpenseForm;
